import { create } from "zustand";

const useOrgStore = create((set) => ({
  organization: null,
  setOrganization: (org) => {
    console.log(org);
    set({ organization: org });
  },
  clearOrganization: () => set({ organization: null }),
}));

export default useOrgStore;
